import { SelectOption } from '@elio/shared/models';

/**
 * Build an array of SelectOption from a model object.
 * @param modelObj
 * @param translatePrefix
 */
export const buildSelectOptionsFromEnumObj = (modelObj: object, translatePrefix: string): SelectOption[] => {
  return Object.values(modelObj).map((value) => ({
    value,
    display: translatePrefix + '.' + value,
  }));
};
